

















import { defineComponent, toRefs } from '@vue/composition-api';
import CoSyncConflictList from '@/renderer/views/desktop/FileManagement/FileSync/components/COSyncConflictDrawer/CoSyncConflictList.vue';

export default defineComponent({
  components: {
    CoSyncConflictList,
  },
  props: {
    show: {
      type: Boolean,
      require: true,
    },
  },
  setup(props, context) {
    const { show } = toRefs(props);
    const handleClose = () => {
      context.emit('close');
    };
    return { innerShow: show, handleClose };
  },
});
